import { ApiError } from '../../../api/client';

/** API field names that live under a different name in our forms. */
const RENAMES: [RegExp, string][] = [
  [/^contactId$/, 'supplier'],
  [/^lines\.(\d+)\.variantId$/, 'lines.$1.variant'],
  [/^discount(\.value)?$/, 'discountValue'],
  [/^lines\.(\d+)\.discount(\.value)?$/, 'lines.$1.discountValue'],
  [/^lines\.(\d+)\.rejectedQty$/, 'lines.$1.rejected'],
  [/^lines\.(\d+)\.rejectReason$/, 'lines.$1.reason'],
];

/**
 * Validation details from an API error (`{ path: 'body.lines.0.qty' }`) as form field paths
 * (`lines.0.qty`). Details that don't name a field are left out.
 */
export function apiFieldErrors(error: unknown): { field: string; message: string }[] {
  if (!(error instanceof ApiError)) return [];
  return error.details
    .map((d) => {
      let field = d.path.replace(/^body\./, '');
      for (const [re, to] of RENAMES)
        if (re.test(field)) {
          field = field.replace(re, to);
          break;
        }
      return { field, message: d.message };
    })
    .filter((d) => d.field && d.field !== 'body');
}
